window.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes('/best-sales') || window.location.href.includes('/dev-')) {
    const crazyRocketIcon = document.querySelector('.crazyrocket-launch-icon');
    if (crazyRocketIcon) {
      crazyRocketIcon.style.display = 'none';
    }
  }

  $('.bs-sku-select').each(function() {
    var $select = $(this);
    // 初始化sku选择器
    $select.select2({
      placeholder: $select.data('placeholder'),
      allowClear: false
    }).on('change', function() {
      skuSelectChange(this);
    });
      
    // 添加默认选择的sku
    const btnCart = $select.closest('.cla-pcard-item').find('.bs-love--btn-cart');
    const selectEL = $select[0];

    var $card = $select.closest('.cla-pcard-item');
    var fixedVid = $card.attr('data-fixed-variant-id');
    var defaultSkuId;
    if (fixedVid) {
      defaultSkuId = fixedVid;
    } else if (selectEL) {
      defaultSkuId = $select.val();
    }
    if (btnCart.length > 0 && defaultSkuId) {
      btnCart.attr('items', JSON.stringify({items: [{ id: defaultSkuId, quantity: 1 }]}));
    }

    // 首屏只展示当前 select 选中的 variant 对应价格（与 skuSelectChange 一致）
    if (selectEL) {
      syncPcardPriceDisplay(selectEL);
    }
  });
});

/**
 * festival：.pcard-price-item-wrapper .pcard-price-item，且带 data-sku-id（由 CSS 控制显隐）
 * section-best-sale-trackit：.p-price .pcard-price-item，无 data-sku-id，按选项顺序对应前两个价格块
 */
function getPcardPriceItems($card) {
  var $inWrapper = $card.find('.pcard-price-item-wrapper .pcard-price-item');
  if ($inWrapper.length) return $inWrapper;
  return $card.find('.p-price .pcard-price-item');
}

function usesJsPriceVisibility($items) {
  return $items.first().closest('.p-price').length > 0;
}

function setPriceItemState($item, isActive, $items) {
  if (isActive) {
    $item.addClass('active');
    if (usesJsPriceVisibility($items)) {
      $item.show();
    }
  } else {
    $item.removeClass('active');
    if (usesJsPriceVisibility($items)) {
      $item.hide();
    }
  }
}

function calcDiscountPct(price, compareAtPrice) {
  if (!compareAtPrice || compareAtPrice <= price) return 0;
  return Math.round((compareAtPrice - price) * 100.0 / compareAtPrice);
}

function getVariantFromCard($card, selectEl) {
  var fixedVid = $card.attr('data-fixed-variant-id');
  if (fixedVid) {
    var $fixedItem = $card.find('.pcard-price-item[data-sku-id="' + fixedVid + '"]');
    if ($fixedItem.length) {
      try {
        return JSON.parse($fixedItem.attr('data-variant-item'));
      } catch (e) {}
    }
  }

  var $items = getPcardPriceItems($card);
  if (!$items.length) return null;

  var selectedId = '';
  if (selectEl) {
    selectedId = String($(selectEl).val() || selectEl.value || '');
    if (!selectedId && selectEl.options && selectEl.selectedIndex > 0) {
      selectedId = String(selectEl.options[selectEl.selectedIndex].value || '');
    }
  }

  var firstSku = $items.first().attr('data-sku-id');
  if (firstSku !== undefined && firstSku !== '' && selectedId) {
    var $matched = $items.filter('[data-sku-id="' + selectedId + '"]');
    if ($matched.length) {
      try {
        return JSON.parse($matched.attr('data-variant-item'));
      } catch (e) {}
    }
  }

  var $active = $card.find('.pcard-price-item.active[data-variant-item]').first();
  if ($active.length) {
    try {
      return JSON.parse($active.attr('data-variant-item'));
    } catch (e) {}
  }

  if (!selectEl || selectEl.selectedIndex <= 0 || selectEl.value === '') return null;
  var variantIdx = selectEl.selectedIndex - 1;
  var $byIndex = $items.eq(variantIdx);
  if ($byIndex.length && $byIndex.attr('data-variant-item')) {
    try {
      return JSON.parse($byIndex.attr('data-variant-item'));
    } catch (e) {}
  }
  return null;
}

function syncAutoDiscountBadge($card, selectEl) {
  var $badge = $card.find('[data-auto-discount="true"]');
  if (!$badge.length) return;

  var variant = getVariantFromCard($card, selectEl);
  var pct = variant ? calcDiscountPct(variant.price, variant.compare_at_price) : 0;
  var prefix = $badge.data('discountPrefix') || '';
  var suffix = $badge.data('discountSuffix') || '';
  var $text = $badge.find('.dis-pcard-text, .p-tag-text').first();

  if (pct <= 0) {
    $badge.hide();
    return;
  }

  $badge.show();
  var $paragraphs = $text.find('p');
  if ($paragraphs.length >= 1) {
    $paragraphs.eq(0).text(prefix + pct + '%');
    if ($paragraphs.length >= 2 && suffix) {
      $paragraphs.eq(1).text(suffix);
    }
  }
}

function syncPcardPriceDisplay(selectEl) {
  var $card = $(selectEl).closest('.cla-pcard-item');
  var $items = getPcardPriceItems($card);
  if (!$items.length) return;

  var firstSku = $items.first().attr('data-sku-id');
  if (firstSku !== undefined && firstSku !== '') {
    var selectedId = String($(selectEl).val() || selectEl.value || '');
    if (!selectedId && selectEl.options && selectEl.selectedIndex > 0) {
      selectedId = String(selectEl.options[selectEl.selectedIndex].value || '');
    }
    $items.each(function() {
      var id = String($(this).attr('data-sku-id') || '');
      setPriceItemState($(this), id === selectedId, $items);
    });
    syncAutoDiscountBadge($card, selectEl);
    return;
  }

  // 无 data-sku-id：下拉第一项为空占位，第 1 个 variant 对应 selectedIndex 1 → 第 1 个价格块
  var si = selectEl.selectedIndex;
  if (si <= 0 || selectEl.value === '') {
    $items.each(function() {
      setPriceItemState($(this), false, $items);
    });
    if (!usesJsPriceVisibility($items)) {
      $items.show();
    }
    syncAutoDiscountBadge($card, selectEl);
    return;
  }
  var variantIdx = si - 1;
  if (variantIdx >= $items.length) {
    $items.each(function() {
      setPriceItemState($(this), false, $items);
    });
    syncAutoDiscountBadge($card, selectEl);
    return;
  }
  $items.each(function(i) {
    setPriceItemState($(this), i === variantIdx, $items);
  });
  syncAutoDiscountBadge($card, selectEl);
}

function skuSelectChange(target) {
  console.log('skuSelectChange', target, target.value);

  var $card = $(target).closest('.cla-pcard-item');
  var btnCart = $card.find('.bs-love--btn-cart');
  var fixedVid = $card.attr('data-fixed-variant-id');
  var resolvedId = fixedVid || target.value;
  syncPcardPriceDisplay(target);

  if (btnCart.length > 0) {
    btnCart.attr('items', JSON.stringify({items: [{ id: resolvedId, quantity: 1 }]}));
  }
}
